import React, { useEffect, useState } from 'react'
import MobileFilterSheet from './mobileFilterSheet'

/**
 * Default/empty state for the trips filter fields, mirroring the fields used
 * by the desktop MyTripsSearch component (fromAddress/toAddress/status/
 * permitNumber/regionName/from/to/bookingNumber/driverNumber/phoneNumber).
 */
export const defaultTripsFilters = {
   fromAddress: '',
   toAddress: '',
   status: 0,
   permitNumber: '',
   regionName: '',
   from: '',
   to: '',
   bookingNumber: '',
   driverNumber: '',
   phoneNumber: ''
}

const inputClass = 'w-full text-sm md:text-base bg-white border border-gray-300 rounded-lg px-3 py-2 md:py-2.5 outline-none focus:border-blue-500'
const inputStyle = { backgroundColor: '#ffffff' }
const labelClass = 'text-sm md:text-base font-medium text-gray-600 block mb-1'

/**
 * Mobile equivalent of components/myTrips/myTripsSearch.js, presented as a
 * bottom sheet. Keeps its own draft state so edits aren't applied until
 * "Søk" is pressed, and resets/re-searches immediately on "Nullstill",
 * matching the desktop reset/search behaviour.
 */
const MobileTripsFilter = ({ open, onClose, values, onApply }) => {
   const [draft, setDraft] = useState(values)

   useEffect(() => {
      if (open) setDraft(values)
   }, [open, values])

   const handleChange = e => {
      const { name, value } = e.target
      setDraft(draft => ({ ...draft, [name]: name === 'status' ? parseInt(value) : value }))
   }

   const handleSearch = () => {
      onApply(draft)
      onClose()
   }

   const handleReset = () => {
      setDraft(defaultTripsFilters)
      onApply(defaultTripsFilters)
      onClose()
   }

   return (
      <MobileFilterSheet open={open} title="Filtrer turer" onClose={onClose} onReset={handleReset} onSearch={handleSearch}>
         <div>
            <label className={labelClass}>Fra Adresse</label>
            <input type="text" name="fromAddress" value={draft.fromAddress} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Til Adresse</label>
            <input type="text" name="toAddress" value={draft.toAddress} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Status</label>
            <select name="status" value={draft.status} onChange={handleChange} className={inputClass} style={inputStyle}>
               <option value="0">Alle</option>
               <option value="3">Aktive</option>
               <option value="4">Ferdige</option>
               <option value="5">Avbrutte</option>
            </select>
         </div>
         <div>
            <label className={labelClass}>Løyve</label>
            <input type="text" name="permitNumber" value={draft.permitNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Kjøreområde</label>
            <input type="text" name="regionName" value={draft.regionName} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div className="grid grid-cols-2 gap-3">
            <div>
               <label className={labelClass}>Fra</label>
               <input
                  type="datetime-local"
                  name="from"
                  value={draft.from}
                  onChange={handleChange}
                  min="2018-06-07T00:00"
                  max="2040-06-14T00:00"
                  className={inputClass}
                  style={inputStyle}
               />
            </div>
            <div>
               <label className={labelClass}>Til</label>
               <input
                  type="datetime-local"
                  name="to"
                  value={draft.to}
                  onChange={handleChange}
                  min="2018-06-07T00:00"
                  max="2040-06-14T00:00"
                  className={inputClass}
                  style={inputStyle}
               />
            </div>
         </div>
         <div>
            <label className={labelClass}>Bookingnummer</label>
            <input type="text" name="bookingNumber" value={draft.bookingNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Sjåførnummer</label>
            <input type="number" name="driverNumber" value={draft.driverNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
         <div>
            <label className={labelClass}>Telefonnummer</label>
            <input type="number" name="phoneNumber" value={draft.phoneNumber} onChange={handleChange} className={inputClass} style={inputStyle} />
         </div>
      </MobileFilterSheet>
   )
}

export default MobileTripsFilter
